/* DateTimeFormatOptions copied from typescript/lib/lib.es5.d.ts */
interface DateTimeFormatOptions {
  localeMatcher?: 'best fit' | 'lookup';
  weekday?: 'long' | 'short' | 'narrow';
  era?: 'long' | 'short' | 'narrow';
  year?: 'numeric' | '2-digit';
  month?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
  day?: 'numeric' | '2-digit';
  hour?: 'numeric' | '2-digit';
  minute?: 'numeric' | '2-digit';
  second?: 'numeric' | '2-digit';
  timeZoneName?: 'long' | 'short';
  formatMatcher?: 'best fit' | 'basic';
  hour12?: boolean;
  timeZone?: string;
}
const formatDateTime = (dateTime: string | Date | number) => {
  if (typeof dateTime === 'string' && /^\d+$/.test(dateTime)) {
    dateTime = parseInt(dateTime, 10);
  }

  const date = new Date(dateTime);

  const options: DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false,
  };
  
  return new Intl.DateTimeFormat('de-DE', options).format(date);
};

const formatDate = (dateTime: string | Date) => {
  const options: DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  };
  return new Intl.DateTimeFormat('de-DE', options).format(new Date(dateTime));
};

export { formatDateTime, formatDate };
